import reject from "ramda/src/reject";
import isNil from "ramda/src/isNil";

export const rejectIsNil = reject(isNil);
